export function pnlPct(position) {
  const entry = Number(position.option_entry || position.entry || 0);
  const current = Number(position.option_current || position.current || 0);

  if (!entry || !current) return 0;

  return ((current - entry) / entry) * 100;
}

export function riskAction(position) {
  const pnl = pnlPct(position);
  const dte = Number(position.dte ?? 999);
  const status = String(position.status || "").toUpperCase();

  if (status === "TARGET_HIT" && dte <= 2) return "EXIT";
  if (status === "TARGET_HIT") return "TAKE_PROFIT";

  if (pnl >= 100) return "SCALE_OUT";
  if (pnl >= 50) return "LOCK_PROFITS";
  if (pnl >= 25) return "TRAIL_STOP";
  if (pnl <= -50) return "CUT_LOSS";

  if (dte <= 1 && pnl > 0) return "TAKE_PROFIT";
  if (dte <= 1 && pnl <= 0) return "EXIT";

  return "HOLD";
}

export function actionColor(action) {
  if (["EXIT", "CUT_LOSS"].includes(action)) return "#ef4444";
  if (["TAKE_PROFIT", "SCALE_OUT", "LOCK_PROFITS"].includes(action)) return "#22c55e";
  if (action === "TRAIL_STOP") return "#f59e0b";
  return "#A0A0A0";
}
